function toggleScrolledClass() {
    const header = document.querySelector('header');

    if (window.innerWidth >= 992) {
        window.scrollY > 0 ? header.classList.add('scrolled') : header.classList.remove('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
}

window.addEventListener('scroll', toggleScrolledClass);
window.addEventListener('resize', toggleScrolledClass);

toggleScrolledClass();